// PublicRoute.js
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { setUserState } from '../../store/user';
import withNavigate from './withNavigate';
import constants from '../../utils/constants';
import API from '../../utils/API';

function PublicRoute(props) {
  const [hasAuthenticatedFinished, setHasAuthenticatedFinished] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    API.authenticate()
      .then((userRes) => {
        let user = userRes.data.user;
        if (user) {
          setUserState(user);
        } else {
          console.log('Invalid credentials');
        }
        setHasAuthenticatedFinished(true);
        setAuthenticated(true);
      })
      .catch((err) => {
        console.log(err);
        setHasAuthenticatedFinished(true);
        setAuthenticated(false);
      });
  }, []);

  if (hasAuthenticatedFinished) {
    if (authenticated) {   
      // If authenticated, redirect to the dashboard
      return <Navigate to="/" replace />;
    } else {
      // If not authenticated, allow access to the login page
      return props.children;
    }
  }

  return null; // Authenticated not done
}

const mapStateToProps = (state) => ({
  user: state.user
})

export default connect(mapStateToProps)(withNavigate(PublicRoute));
